
export const answerChildAddressQuestions = (questions: any[], address: Address, questionPosition: string) => {

    let questionIdPositionItems = questionPosition.split('|');
    let parentID = questionIdPositionItems[0].split('-')[0];
    let childID = questionIdPositionItems[1].split('-')[0];
    let childIndex = questionIdPositionItems[1].split('-')[1];

    const newQuestions = questions.map(question => {
        if (question.questionSetQuestion.questionID == parentID) {

            if (question.childInformation != null) {
                let newChildren = question.childInformation.map((childQuestion: any) => {
                    if (childQuestion.index.toString() === childIndex) {
                        switch (childQuestion.questionSetQuestion.text.toLowerCase()) {
                            case 'house':
                                if (address.house != null) {
                                    childQuestion.answer = address.house;
                                    dispatchUpdateAnswerAtIndexEvent(childQuestion.questionSetQuestion.questionID, address.house, childIndex);
                                }
                                break;
                            case 'address 1':
                                if (address.house != null) {
                                    childQuestion.answer = address.house;
                                    dispatchUpdateAnswerAtIndexEvent(childQuestion.questionSetQuestion.questionID, address.house, childIndex);
                                }
                                break;
                            case 'street':
                                if (address.street != null) {
                                    childQuestion.answer = address.street;
                                    dispatchUpdateAnswerAtIndexEvent(childQuestion.questionSetQuestion.questionID, address.street, childIndex);
                                }
                                break;
                            case 'address 2':
                                if (address.street != null) {
                                    childQuestion.answer = address.street;
                                    dispatchUpdateAnswerAtIndexEvent(childQuestion.questionSetQuestion.questionID, address.street, childIndex);
                                }
                                break;
                            case 'locality':
                                if (address.locality != null) {
                                    childQuestion.answer = address.locality;
                                    dispatchUpdateAnswerAtIndexEvent(childQuestion.questionSetQuestion.questionID, address.locality, childIndex);
                                }
                                break;
                            case 'town':
                                if (address.locality != null) {
                                    childQuestion.answer = address.locality;
                                    dispatchUpdateAnswerAtIndexEvent(childQuestion.questionSetQuestion.questionID, address.locality, childIndex);
                                }
                                break;
                            case 'city':
                                if (address.city != null) {
                                    childQuestion.answer = address.city;
                                    dispatchUpdateAnswerAtIndexEvent(childQuestion.questionSetQuestion.questionID, address.city, childIndex);
                                }
                                break;
                            case 'country':
                                if (address.country != null) {
                                    childQuestion.answer = address.country;
                                    dispatchUpdateAnswerAtIndexEvent(childQuestion.questionSetQuestion.questionID, address.country, childIndex);
                                }
                                break;
                            case 'county':
                                if (address.county != null && address.county.length > 0) {
                                    childQuestion.answer = address.county;
                                    dispatchUpdateAnswerAtIndexEvent(childQuestion.questionSetQuestion.questionID, address.county, childIndex);
                                }
                                break;
                            case 'postcode':
                                if (address.postcode != null) {
                                    childQuestion.answer = address.postcode;
                                    dispatchUpdateAnswerAtIndexEvent(childQuestion.questionSetQuestion.questionID, address.postcode, childIndex);
                                }
                                break;
                            case 'please enter the business postcode, and then click search':
                                if (address.postcode != null) {
                                    childQuestion.answer = address.postcode;
                                    dispatchUpdateAnswerAtIndexEvent(childQuestion.questionSetQuestion.questionID, address.postcode, childIndex);
                                }
                                break;
                            default:
                                childQuestion.answer = "";
                                break;
                        }
                    }

                    return childQuestion;
                });

                question.childInformation = [...newChildren];
            }
        }
        return question;
    });

    return newQuestions;
}

const dispatchUpdateAnswerAtIndexEvent = (questionID: string, answer: string, index: string) => {
    var updateAnswerEvent = new CustomEvent("updateAnswerAtIndex", {
        "detail": { "questionID": questionID, "answer": answer, "index": index }
    });

    document.dispatchEvent(updateAnswerEvent);
}